module.exports = __webpack_public_path__ + "static/media/coaching-coachingSkills-powerfulQuestions-technique-es.0fb7c24f.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/pathways/coaching-coachingSkills-powerfulQuestions-technique-es.md
// module id = 535
// module chunks = 18